import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  HostListener,
  Injector,
  Input,
  OnInit
} from '@angular/core';
import { AbstractCommentButtonComponent } from '../abstract-comment-button/abstract-comment-button.component';

@Component({
  selector: 'app-comment-bubble',
  templateUrl: './comment-bubble.component.html',
  styleUrls: ['./comment-bubble.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentBubbleComponent extends AbstractCommentButtonComponent implements OnInit {
  @HostBinding('class')
  private get classes(): string {
    return `flex items-center justify-center w-7 h-7 group relative font-secondary font-bold text-base ${this.disabled ? '' : 'cursor-pointer'}`;
  }

  @HostBinding('class.hidden')
  private get shouldHide(): boolean {
    return !this.commentsAndRepliesExist && this.shouldHideIfNoComments;
  }

  @Input()
  shouldHideIfNoComments: boolean;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  @HostListener('click')
  private onBubbleClick(): void {
    if (this.disabled) {
      return;
    }

    this.commentingUserEventsService.trackFocusThreadEventAsync(this.resourceType, this.resourceId, this.commentsAndRepliesCount);
  }
}
